import {
  LayoutButtonsCheckout,
  LayoutPaddinCheckout,
  Summary,
  Timer,
} from "@/Components/Index";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";

type Props = {
  MDatos: MCheckout[];
  PrintTitle: string;
  clickDelete: () => void;
  ViewForm: boolean;
  handleClick: (value: boolean) => void;
};

export const ProductCheckoutView = ({
  MDatos,
  PrintTitle,
  clickDelete,
  ViewForm,
  handleClick
}: Props): JSX.Element => {
  return (
    <>
      <div className="d-flex flex-column">
        <Timer inicilizarTimer={120000} clickDelete={clickDelete} />
        <h3 className="develop___text text-center">Resumen del pedido</h3>
        <Summary
          mDatos={MDatos}
          quantity={Number(MDatos[0]?.quant)}
          totales={Number(MDatos[0]?.totalSalesPrice)}
        />
      </div>
      <div className="text_Center___develop">
        <h3 className="develop___text">Selecciona método de entrega</h3>
      </div>
      <LayoutButtonsCheckout>
        <LayoutPaddinCheckout>
          <button
            className={
              !ViewForm
                ? "develop__buttons develop___btnsoriana-pick-up develop__disabled"
                : "develop__buttons develop___btnsoriana-pick-up develop__invabled"
            }
            onClick={() => handleClick(true)}>
            <div className="main-text">
              <span className="text-red">Pick {""}</span>
              <span className="text-green">{""} up</span>
            </div>
            <div className="main-text main-text-com">
              <span className="small-text">
                {" "}
                soriana {""}
                {""}
              </span>
              <span className="small-text-com">{""} .com</span>
            </div>
          </button>
        </LayoutPaddinCheckout>
        <LayoutPaddinCheckout>
          <button
            className={
              ViewForm
                ? "develop__buttons develop___btnsoriana-domicilio develop__disabled"
                : "develop__buttons develop___btnsoriana-domicilio develop__invabled"
            }
            onClick={() => handleClick(false)}>
            <div className="main-text">
              <i className="fa-sharp fa-solid fa-truck truck-icon"></i>
              <div className="d-flex flex-column">
                <span className="text-green">Envío a</span>
                <span className="text-red-bg">domicilio</span>
              </div>
            </div>
          </button>
        </LayoutPaddinCheckout>
      </LayoutButtonsCheckout>
      <div
        className="text_Center___develop"
        style={{ marginTop: "20px", marginBottom: "20px" }}>
        <div className="develop___text__checkout">
          <span>
            {PrintTitle == "Recoger en tienda" ? PrintTitle + ":" : PrintTitle}
          </span>
        </div>
        <div style={{ marginTop: "-8px" }}>
          <span className="develop___text__checkout_one">
            {PrintTitle == "Recoger en tienda" ? "Soriana Híper San Pedro" : ""}
          </span>
          <div style={{ marginTop: "-5px" }}>
            <span>
              {PrintTitle == "Recoger en tienda" ? "(en 5 días hábiles)" : ""}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
